(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["creator-videos"] && !Shopify.designMode) return;
  try {
    class CreatorVideos extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-creator-video-open]'));
      this.templates = this.cards.map((card) => this.querySelector(`[data-creator-video-template="${card.dataset.creatorVideoOpen}"]`));
      this.modal = this.querySelector('.creator-videos-block__modal, .creator-videos__modal');
      this.dialog = this.querySelector('.creator-videos-block__dialog, .creator-videos__dialog');
      this.closeButton = this.querySelector('.creator-videos-block__close, .creator-videos__close');
      this.previousButton = this.querySelector('.creator-videos-block__arrow--prev, .creator-videos__arrow--prev');
      this.nextButton = this.querySelector('.creator-videos-block__arrow--next, .creator-videos__arrow--next');
      this.previewVideos = Array.from(this.querySelectorAll('.creator-videos-block__video, .creator-videos__video'));
      this.visiblePreviewVideos = new Set();
      this.activeIndex = 0;
      this.handleVisibilityChange = () => {
        if (document.hidden) {
          this.pauseAllPreviews();
        } else {
          this.playVisiblePreviews();
        }
      };

      this.cards.forEach((card, index) => {
        card.addEventListener('click', () => this.open(index));
      });
      this.closeButton?.addEventListener('click', () => this.close());
      this.previousButton?.addEventListener('click', () => this.show(this.activeIndex - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.activeIndex + 1));
      this.modal?.addEventListener('click', (event) => {
        if (event.target === this.modal) this.close();
      });
      document.addEventListener('keydown', (event) => {
        if (!this.modal || this.modal.hidden) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.show(this.activeIndex - 1);
        if (event.key === 'ArrowRight') this.show(this.activeIndex + 1);
      });

      if (this.dataset.autoplay === 'true') {
        this.setupLazyPreviewAutoplay();
      } else {
        this.pauseAllPreviews();
      }
    }

    disconnectedCallback() {
      this.previewObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    setupLazyPreviewAutoplay() {
      this.previewVideos.forEach((video) => {
        video.muted = true;
        video.preload = 'none';
      });

      if ('IntersectionObserver' in window) {
        this.previewObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                this.visiblePreviewVideos.add(video);
                this.playPreview(video);
              } else {
                this.visiblePreviewVideos.delete(video);
                this.pausePreview(video);
              }
            });
          },
          {
            root: null,
            rootMargin: '160px 80px',
            threshold: [0, 0.35, 0.65],
          }
        );

        this.previewVideos.forEach((video) => this.previewObserver.observe(video));
      } else {
        this.previewVideos.slice(0, 3).forEach((video) => {
          this.visiblePreviewVideos.add(video);
          this.playPreview(video);
        });
      }

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    playPreview(video) {
      if (!video || document.hidden || (this.modal && !this.modal.hidden)) return;
      video.muted = true;
      video.play?.().catch(() => {});
    }

    pausePreview(video) {
      video?.pause?.();
    }

    playVisiblePreviews() {
      if (this.dataset.autoplay !== 'true') return;
      this.visiblePreviewVideos.forEach((video) => this.playPreview(video));
    }

    pauseAllPreviews() {
      this.previewVideos.forEach((video) => this.pausePreview(video));
    }

    open(index) {
      if (!this.modal || !this.dialog) return;
      this.pauseAllPreviews();
      this.modal.hidden = false;
      document.documentElement.classList.add('creator-videos-open');
      this.show(index);
    }

    show(index) {
      if (!this.templates.length || !this.dialog) return;
      this.activeIndex = (index + this.templates.length) % this.templates.length;
      const template = this.templates[this.activeIndex];
      if (!template) return;
      this.dialog.replaceChildren(template.content.cloneNode(true));
      const video = this.dialog.querySelector('video');
      if (video) video.play?.().catch(() => {});
    }

    close() {
      if (!this.modal || !this.dialog) return;
      this.modal.hidden = true;
      this.dialog.replaceChildren();
      document.documentElement.classList.remove('creator-videos-open');
      this.playVisiblePreviews();
    }
  }

  if (!customElements.get('creator-videos')) {
    customElements.define('creator-videos', CreatorVideos);
  }
  } catch(e) { console.error(e); }
})();

})();
